<template>

  <section id="head">
    <div class="container col-xl-12 col-xxl-12 px-4 py-5 bgTop posRel">
      <div class="row align-items-center g-lg-5 py-5">
        <div class="col-lg-4 text-center text-lg-start alignFix posRel">
          <div class="assistant">
            <div class="row assHead g-0">
              <div class="col-2 pic"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/IlariaRav1.png"></div>
              <div class="col-8 txt"> Ilaria <div>✈ Servizio Clienti Rimborso al Volo</div>
              </div>
            </div>
            <div class="row assContent g-0">
              <div class="col-2 pic"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/IlariaRimborsoalVolo.jpg"></div>
              <div class="col-10 txt"> Inserire la data esatta è fondamentale. Ci consentirà di verificare diverse informazioni cruciali relative al tuo reclamo. Seleziona con attenzione anche il tipo
                di problema 🤓</div>
            </div>
          </div>
        </div>
        <div class="col-lg-8 bgWight formStyle posRel">
          <div class="headForm">
            <img class="logo" src="https://www.rimborsoalvolo.it/cresources/outform/images/rimborsoalvolo-logo.svg">
          </div>
          <div class="p-4 p-md-4 ">
            <div class="form-floating mb-3 ">
              <div class="g-2">{{  $t('message.gen_data_volo_label') }} *</div>

              <Datepicker id="datavolo" v-model="datavolo" :locale="this.$root.$i18n.locale" format="dd/MM/yyyy" autoApply v-bind:placeholder="$t('message.gen_data_volo')" :enableTimePicker="false"
                          v-bind:class="[v$.datavolo.isDate.$invalid && showerrors ? 'form-error' : '']" ></Datepicker>

              <div class="error" v-if="(v$.datavolo.isDate.$invalid || v$.datavolo.required.$invalid) && showerrors">{{ $t("message.st1_data_volo_required") }}</div>
              <div class="error" v-if="(dataeccedente && showerrors)">{{ $t("message.st1_data_volo_eccedente") }}</div>
              <div class="error" v-if="(showTerminiScaduti)">{{ $t("message.err_terminiscaduti_msg") }}</div>
              <div class="error" v-if="(showDataLimitata)">{{ $t("message.err_datalimitata") }}</div>
            </div>
            <div class="form-floating mb-3 fixLabel">
              <div class="g-2">{{ $t("message.st1_tipologia_problema_label") }}  *</div>
              <select class="form-select" id="problema" name="select"  v-model="problematica" v-bind:class="[v$.problematica.required.$invalid && showerrors ? 'form-error' : '']">
                <option value="" selected disabled>{{ $t("message.st1_tipologia_problema") }}</option>
                <option value="1">{{ $t("message.st2_problematica_ritardo") }}</option>
                <option value="2">{{ $t("message.st2_problematica_cancellazione") }}</option>
                <option value="3">{{ $t("message.st2_problematica_bagaglio") }}</option>
                <option value="4">{{ $t("message.st2_problematica_overbooking") }}</option>
              </select>
              <div class="error" v-if="(v$.problematica.required.$invalid ) && showerrors">{{ $t("message.st1_tipologia_problema_required") }}</div>
            </div>
            <div class="form-floating mb-3 fixLabel" v-if="problematica == 1 || problematica == 2">
              <!-- ritardo o cancellazione -->
              <div class="form-floating mb-3 ">
                <div class="g-2">Data in cui hai ricevuto la comunicazione <span v-if="problematica == 1">del ritardo</span> <span v-if="problematica == 2">della cancellazione</span> del volo ?</div>

                <Datepicker id="datavolo" v-model="datacomunicazione" :locale="this.$root.$i18n.locale" format="dd/MM/yyyy" autoApply placeholder="Data comunicazione" :enableTimePicker="false"
                            v-bind:class="[v$.datacomunicazione.isNullableDate.$invalid && showerrors ? 'form-error' : '']" :disabled="nessunacomunicazione"></Datepicker>
              </div>
              <div class="error" v-if="(v$.datacomunicazione.required.$invalid ) && showerrors">Inserire la data di comunicazione da parte della compagnia</div>
              <div class="form-check form-switch">
                <label class="form-check-label" for="flexSwitchCheckDefault">Non ho ricevuto alcuna comunicazione</label>
                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault"  v-model="nessunacomunicazione">
              </div>

            </div>
            <div class="form-floating mb-3 fixLabel" v-if="problematica == 3">
              <!-- bagaglio -->
              <div class="form-floating mb-3 ">
                <div class="g-2">Data in cui ti è stato riconsegnato il bagaglio ?</div>

                <Datepicker id="datavolo" v-model="datariconsegnabagaglio" :locale="this.$root.$i18n.locale" format="dd/MM/yyyy" autoApply placeholder="Data riconsegna bagaglio" :enableTimePicker="false"
                            v-bind:class="[v$.datariconsegnabagaglio.isNullableDate.$invalid && showerrors ? 'form-error' : '']" :disabled="bagagliononriconsegnato"></Datepicker>
              </div>
              <div class="error" v-if="(v$.datariconsegnabagaglio.required.$invalid ) && showerrors">Inserire la data di riconsegna del bagaglio</div>
              <div class="form-check form-switch">
                <label class="form-check-label" for="flexSwitchCheckDefault1">Il bagaglio non è stato ancora riconsegnato</label>
                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault1"  v-model="bagagliononriconsegnato">
              </div>
            </div>


            <div class="form-floating mb-3 fixLabel" v-if="problematica == 2 || problematica == 4">
              <!-- riprotezione-->
              <div class="form-floating mb-3 ">
                <div class="g-2"><div class="form-check form-switch">
                  <label class="form-check-label" for="flexSwitchCheckDefault2">Riprotezione da parte della compagnia ? </label>
                  <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault2"  v-model="riprotezionecompagnia">
                </div></div>

                <Datepicker id="datavolo" v-model="datariprotezione" :locale="this.$root.$i18n.locale" format="dd/MM/yyyy" autoApply placeholder="Data riprotezione" :enableTimePicker="false"
                            v-bind:class="[v$.datariprotezione.isNullableDate.$invalid && showerrors ? 'form-error' : '']" :disabled="!riprotezionecompagnia"></Datepicker>
              </div>
              <div class="error" v-if="(v$.datariprotezione.required.$invalid ) && showerrors">Inserire la data del volo di riprotezione</div>

            </div>

            <div class="row mb-3">
              <div class="col-md-12">
              <div class="form-check form-switch">
                <label class="form-check-label" for="flexSwitchCheckDefault3">{{ $t("message.st2_domanda_coincidenze") }}</label>
                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault3"  v-model="coincidenzepresenti">
              </div>
              </div>
            </div>
            <div class="row g-3 mt-3">
              <div class="col-md-4 order-md-3">
                <span><img class="fixIndietro pointerBtn" src="https://www.rimborsoalvolo.it/cresources/outform/images/indietro.png" @click="precedente()"></span>
                <button type="submit" class="btn styleBtn mb-3 float-end" @click="submit()">{{ $t("message.gen_btn_avanti") }}</button>
              </div>
              <div class="col-md-4 order-md-1">
                <p class="txtFooForm"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/trustpilot-2.svg">Trustpilot 4,9/5 Eccezionale</p>
              </div>
              <div class="col-md-4 order-md-2">
                <p class="txtFooForm"><img class="cuffieAssistenza" src="https://www.rimborsoalvolo.it/cresources/outform/images/cuffieAssistenza.png" alt="">Assistenza telefonica.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
    <trust-pilot></trust-pilot>
    <conteggio-reclami></conteggio-reclami>
    <recensioni-f-b></recensioni-f-b>
    <sezione-a-p-r-a></sezione-a-p-r-a>
    <page-footer></page-footer>

</template>

<script>
import {useStore} from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, helpers, requiredIf } from "@vuelidate/validators";
import Datepicker from '@vuepic/vue-datepicker';

import moment from "moment";
import { verificaTicketChiusiOK } from "@/lib/verifiche";
import {computed} from "vue";
import {verificaStep} from "@/lib/verificaStep";
import FakeChat from "@/components/FakeChat";
import ConteggioReclami from "@/components/ConteggioReclami";
import TrustPilot from "@/components/TrustPilot";
import RecensioniFB from "@/components/RecensioniFB";
import SezioneAPRA from "@/components/SezioneAPRA";
import PageFooter from "@/components/PageFooter";


const isDate = helpers.withParams(
    {type:'isDate'},
    (value)=>{ let tdate = moment(value); return tdate.isValid()}
);

const isNullableDate = helpers.withParams(
    {type:'isDate'},
    (value)=>{ if(value === null) return true; let tdate = moment(value); return tdate.isValid()}
);

export default {
  name: "SecondoStep",
  components:{

    Datepicker,
      PageFooter,
      SezioneAPRA,
      RecensioniFB,
      TrustPilot,
      ConteggioReclami,
      FakeChat,
  },
  setup() {
    const store = useStore();
    const datalimitata = computed(()=>store.state.volo.datalimitata15ottobre2021);
    const s_datavolo = computed(()=>store.state.volo.datavolo);
    const s_problematica = computed(()=>store.state.volo.tipoproblema);
    const s_completati = computed(()=>store.state.compilazione.stepcompletati);
    const s_step2_inviato = computed( ()=>store.state.gtmstate.step2inviato);
    return {
      datalimitata,
      s_datavolo,
      s_problematica,
      s_completati,
      s_step2_inviato,
      v$: useVuelidate(),
      setDataVolo : function(datavolo){
        store.dispatch('volo/commitDataVolo',datavolo);
      },
      setTipologiaProblema: function(tipologiaproblema){
        store.dispatch('volo/commitTipologiaProblema',tipologiaproblema)
      },
      setTicketChiusiOkAssociati: function(value){
        store.dispatch('compilazione/commitTicketChiusiOkAssociati',value);
      },
      setCoincidenzePresenti: function(value){
        store.dispatch('volo/commitSetCoincidenzePresenti',value);
      },
      setDataRiconsegnaBagaglio: function(value){
        store.dispatch('volo/commitSetDataRiconsegnaBagaglio',value);
      },
      setBagaglioNonRiconsegnato: function(value){
        store.dispatch('volo/commitSetBagaglioNonRiconsegnato',value);
      },
      setNessunaComunicazione: function(value){
        store.dispatch('volo/commitSetNessunaComunicazione',value);
      },
      setDataComunicazione: function(value){
        store.dispatch('volo/commitSetDataComunicazione',value);
      },
      getCompagnia: function(){
        return store.getters["volo/getCompagnia"];
      },
      getNumeroVolo: function(){
        return store.getters["volo/getNumeroVolo"];
      },
      setStepCompletato: function(){
        store.dispatch('compilazione/commitSetStepCompletato',2);
      },
      setDataRiprotezione: function(value){
        store.dispatch('volo/commitSetDataRiprotezione',value);
      },
      getStepCompletati: function(){
        return store.getters["compilazione/getStepCompletati"];
      },
      setStep2Inviato: function(){
        store.dispatch('gtmstate/commitSetStatoInvio2',true);
      }
    }
  },

  data(){
    return {
      datavolo: this.s_datavolo != null ? this.s_datavolo : null,
      problematica: this.s_problematica != null ? this.s_problematica : "",
      showerrors : false,
      dataeccedente : false,
      showTerminiScaduti: false,
      dataLimitataAOttobre2021 :this.datalimitata,
      showDataLimitata: false,
      coincidenzepresenti: false,
      datacomunicazione : null,
      nessunacomunicazione : false,
      datariconsegnabagaglio : null,
      bagagliononriconsegnato: false,
      riprotezionecompagnia : false,
      datariprotezione: null,
    }
  },
  validations(){
    let vm = this;
    return {
      datavolo: { required, isDate },
      problematica: { required },
      datacomunicazione : { isNullableDate,
        required:requiredIf(function(){
          return (vm.problematica == 1 || vm.problematica == 2) && (vm.nessunacomunicazione == false);
        })
      },
      datariprotezione: {
        isNullableDate,
        required:requiredIf(function(){
          return (vm.problematica == 2 || vm.problematica == 4) && (vm.riprotezionecompagnia);
        })
      },
      datariconsegnabagaglio : { isNullableDate,
        required:requiredIf(function(){
          return ( vm.problematica == 3 && vm.bagagliononriconsegnato == false);
        })
      },

    }
  },
  watch:{
    datavolo:function(value){
      let target = new moment(value);
      if(!target.isValid()) return;
      let now = moment(moment().format('DD/MM/YYYY'),'DD/MM/YYYY')
      if(target.diff(now,'days') > 14){
        this.dataeccedente = true;
        this.showerrors = true;
      }else this.dataeccedente = false;
    }
  },
  mounted() {

    let step = verificaStep([...this.s_completati]);
    if(step.step <= 1){ this.$router.push(step.url) ;}
    else if(step.step > 4) {this.$router.push({name:'step5'});}

    window.scrollTo(0,0);
    if(!this.s_step2_inviato) {
      this.setStep2Inviato();
      this.$gtm.trackEvent({
            event: 'step_visitato',
            value: 2,
          }
      );

      if(typeof fbq !== 'undefined') {
        fbq('track','PageView');
        fbq('trackCustom','Step2');
      }

    }

  },
  methods: {
    salvaDati(){
      this.setDataVolo(this.datavolo);
      this.setTipologiaProblema(this.problematica);
      this.setCoincidenzePresenti(this.coincidenzepresenti);
      this.setNessunaComunicazione(this.nessunacomunicazione);
      this.setBagaglioNonRiconsegnato(this.bagagliononriconsegnato);
      this.setDataRiconsegnaBagaglio(this.datariconsegnabagaglio);
      this.setDataComunicazione(this.datacomunicazione);
      this.setDataRiprotezione(this.datariprotezione);
    },
    async submit(){
      const valid = await this.v$.$validate();
      if(!valid){
        this.showerrors = true;
        return;
      }

      let days = moment().diff(moment(this.datavolo),'days');
      if(this.dataeccedente){
        this.showerrors = true;
        return;
      }
      else if(days > 730) {
        this.showTerminiScaduti = true;
        return;
      }
      else if(this.dataLimitataAOttobre2021 && moment(this.datavolo).isBefore(moment('15/10/2021','DD/MM/YYYY'))){
        this.showDataLimitata = true;
        return;
      }
      verificaTicketChiusiOK(this.getCompagnia().id,this.getNumeroVolo(),moment(this.datavolo).format('DD/MM/YYYY')).then((result)=>{
        if(result) {
          this.setTicketChiusiOkAssociati(result);
        }
      }).catch((err)=>{ console.log(err);})
      this.salvaDati();
      this.prossimoStep();
    },
    prossimoStep(){
      this.setStepCompletato();
      this.$router.push({name:'step3'});
    },
    precedente(){
      this.$router.push({name:'step1'});
    }
  }
}
</script>

<style>
.dp__input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
  color:    #000;
}

.dp__input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
   color:    #000;
   opacity:  1;
 }
.dp__input::-moz-placeholder { /* Mozilla Firefox 19+ */
  color:    #000;
  opacity:  1;
}
.dp__input:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color:    #000;
}

.dp__input::-ms-input-placeholder { /* Microsoft Edge */
  color:    #000;
}

.dp__input::placeholder { /* Most modern browsers support this now. */
  color:    #000;
}

.dp__input {
  background-color: var(--dp-background-color);
  border-radius: 4px;
  font-family: -apple-system,blinkmacsystemfont,"Segoe UI",roboto,oxygen,ubuntu,cantarell,"Open Sans","Helvetica Neue",sans-serif;
  border: 1px solid var(--dp-border-color);
  outline: none;
  transition: border-color .2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  font-size: 1rem;
  line-height: 1.5rem;
  padding: 5px 28px;
  color: var(--dp-text-color);
  box-sizing: border-box;
  min-height: 58px;
}

.pointerBtn {
  cursor: pointer;
}

</style>
